import React, { Fragment } from "react";

import Link from "components/shared/Link/Link";
import LoginDivider from "components/Login/LoginDivider";
import LoginImageRow from "./LoginImageRow";
import LoginPage from "components/Login/LoginPage";

import {
  ENABLE_LOGIN_HOME,
  ENABLE_LOGIN_TOPBAR,
  ENABLE_REGISTER_PAGES,
  PRIVACY_PAGE_LINK
} from "config";

import {
  PROJECT_LOGIN_HOME,
  LOGIN_HOME,
  PROJECT_REGISTER,
  REGISTER
} from "App/Routes";
import localize from "lang/localize";

import "./Login.css";

class NinjavilleLoginPage extends LoginPage {
  renderGuestLoginSection() {
    if (this.props.projectId && this.props.guestEnabled) {
      return (
        <Fragment>
          <LoginDivider />
          <br />
          <div className="pure-g">
            <div className="pure-u-1-12" />
            <div className="pure-u-5-6">
              <button
                className="button button-login-guest lowercase fullwidth cta"
                onClick={this.props.handleOpenGuestLoginDialog}
              >
                {localize("dialog_login_guest_title", this.props.language)}
              </button>
              {this.props.showGuestLoginDialog && this.renderGuestLoginDialog()}
            </div>
            <div className="pure-u-1-12" />
          </div>
          <br />
        </Fragment>
      );
    } else {
      return null;
    }
  }

  /*
    Custom: Register section will be rendered only if Register is enabled
    and Login Home is disabled
  */
  renderRegisterSection() {
    if (!ENABLE_LOGIN_HOME) {
      return (
        <Fragment>
          <br />
          <p className="textcenter">
            <strong>
              {localize("login_view_register_start", this.props.language) + " "}
            </strong>
            <Link
              to={
                this.props.projectId
                  ? PROJECT_REGISTER.format(this.props.projectId)
                  : REGISTER
              }
              className="default"
            >
              {localize("login_view_signup_text", this.props.language)}
            </Link>
          </p>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  render() {
    if (
      typeof this.props.showPrivacyAgreement === "boolean" &&
      this.props.showPrivacyAgreement === true
    ) {
      /* checking type is important: showPrivacyAgreement is initialised as null */
      return (
        <div className="login-register-container container verticalpadding">
          {/* Custom: back button logic */}
          {ENABLE_LOGIN_HOME && (
            <Link
              className="login-back-button"
              to={
                this.props.projectId
                  ? PROJECT_LOGIN_HOME.format(this.props.projectId)
                  : LOGIN_HOME
              }
            >
              <i className="fas fa-arrow-left" />
            </Link>
          )}
          <LoginImageRow />
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-1-12 pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-5-6 pure-u-sm-16-24 pure-u-md-1-2 login-panel">
              <h5>
                {localize(
                  "login_view_privacy_policy_updated_title",
                  this.props.language
                )}
              </h5>
              <p>
                {localize("login_agree_to_new_terms_text", this.props.language)}
              </p>
              <div className="bottommargin-30">
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdatePrivacyAgreed}
                    checked={this.props.privacyAgreed}
                  />{" "}
                  {localize(
                    "register_agree_to_gametize_text",
                    this.props.language
                  )}
                  <a
                    className="link default"
                    href={PRIVACY_PAGE_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {localize(
                      "register_privacy_policy_text",
                      this.props.language
                    )}
                  </a>
                  .
                </p>
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdateMarketingConsent}
                    checked={this.props.marketingConsent}
                  />{" "}
                  {localize(
                    "register_marketing_communications_text",
                    this.props.language
                  )}
                </p>
              </div>
              <div className="pure-g bottommargin">
                <div className="pure-u-11-24 pure-u-sm-14-24 pure-u-lg-2-3" />
                <div className="pure-u-13-24 pure-u-sm-10-24 pure-u-lg-1-3">
                  <button
                    className={
                      "button fullwidth " +
                      (this.props.privacyAgreed ? "cta" : "inactive")
                    }
                    onClick={this.props.handlePrivacySubmit}
                    disabled={!this.props.privacyAgreed}
                  >
                    {localize("button_quest_continue", this.props.language)}
                  </button>
                </div>
              </div>
            </div>
            <div className="pure-u-1-12 pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    } else {
      return (
        <div className="login-register-container container verticalpadding">
          {this.renderTopbarlessBackButton()}
          <LoginImageRow />
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-1-12 pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-5-6 pure-u-sm-16-24 pure-u-md-1-2 login-panel">
              <form
                className="pure-form"
                onSubmit={this.handlePreSubmit.bind(this)}
              >
                {this.renderLoginFields()}
                {this.renderGuestLoginSection()}
                {this.renderSSOLoginSection()}
                {ENABLE_REGISTER_PAGES && this.renderRegisterSection()}
              </form>
            </div>
            <div className="pure-u-1-12 pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    }
  }
}

export default NinjavilleLoginPage;
